export default __webpack_public_path__ + "static/media/papaerclip_s.ae10fd08.svg";